<template>
    <div class="_content">
        <div class="today_order">
            <span>{{this.todayListData.total || '0'}}单</span>
            <span>今日订单</span>
        </div>
        <van-cell-group>
        <van-cell title="今日订单列表" value=""/>

            <van-cell 
            v-for="(item,index) in todayListData.list" :key="index"
            class="today_order_list" 
            @click="handleClick(tabList[0],index)"
            :title="item.secondClassName"
            :label="item.createdTime"
            center>
                <template #right-icon>
                    <van-icon name="arrow" style="line-height: inherit;" />
                </template>
            </van-cell>

        </van-cell-group>

        <!-- 分页   :total-items="this.recordsData.total"总数量   -->
        <van-pagination
            v-model="currentPage"
            :total-items="this.todayListData.total"
            v-if="this.todayListData.total > 6"
            items-per-page="6"
            force-ellipses
            show-page-size="3"
            @change="changePage($event)"
            class="today_pagination"
        />
    </div>
</template>
<script>
import config from '@/configs/config'
export default {
    data() {
        return {
            shopId: '',
            currentPage: 1,
            todayListData: {},
            tabList: [{
                name: '今日订单列表详情',
                url: '/pages/orderDetail/index'
            }],
            dataCode: null
        }
    },
    created() {
        this.getTodayList()
    },
    methods: {
        async getTodayList() {
            // 权限信息
            const roleData = await tuhu.fetch(`${config.apis.GET_USERINFO}`)
            if (roleData && roleData.code === '200') {
                this.shopId = roleData.data.shopId
            } else {
                tuhu.toast(roleData.message || '获取权限信息失败')
            }
            // 今日订单列表
            const data = await tuhu.fetch(`${config.apis.GET_TODAYORDER_LIST}`, {
                method: 'post',
                body: JSON.stringify({
                    'pageNum': 1,
                    'pageSize': 6,
                    'shopId': this.shopId
                })
			})
            if (data && data.code === '200') {
                this.todayListData = data.data
                this.dataCode = 200
            } else {
                tuhu.toast(data.message || '网络错误')
            }
        },
        // 分页事件
        async changePage(index) {
            const pageNum = index
            let data = await tuhu.fetch(`${config.apis.GET_TODAYORDER_LIST}`, {
                method: 'post',
                body: JSON.stringify({
                        pageNum: pageNum,
                        pageSize: 6,
                        shopId: this.shopId
                })
            })
            if (data && data.code === '200') {
                this.todayListData = data.data
            } else {
				tuhu.toast(data.message || '网络错误')
            }
        },
        handleClick (item, index) {
			tuhu.sessionStorage.setItem('shopOrderDetail', JSON.stringify(this.todayListData.list[index]))
            let i = index
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ListInfo: this.todayListData.list[i] || {}
                },
                query: {
					scsShow: 1
				}
            })
        }
    }
}
</script>
<style lang="less" scoped>
    .today_order{
        width: 100%;
        height: 7.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: rgb(55,149,240);
        color: #fff;
        >span:nth-child(1) {
        font-size: 2rem;
        }
    }
    .today_order_list{
            display: flex;
            flex-direction: row;
            justify-items: center;
            justify-content: center;

    }
    .today_pagination{
        margin-top: 1.35rem;
    }
</style>


// WEBPACK FOOTER //
// src/pages/orderToday/index.vue